import { axios, defaultAxios } from "./api"

const defaultGet = (url) => {
    const ax = defaultAxios.create({headers: {'Content-Type': 'application/json'}})
    return ax.get(url)
}

// ===== OAuth App (for normal users - no org requirement) =====
const getAccessToken = (code) => {
    return axios.get(`/auth/oauth/token/${code}`)
}

const getRefreshedAccessToken = (refreshToken) => {
    return axios.post('/auth/oauth/refresh', {refreshToken})
}

// ===== GitHub App (for admins - requires org membership) =====
const getAdminAccessToken = (code) => {
    return axios.get(`/auth/github-app/token/${code}`)
}

const getAdminRefreshedToken = (refreshToken) => {
    return axios.post('/auth/github-app/refresh', {refreshToken})
}

// ===== Local Auth (for super admin) =====
const superAdminLogin = (username, password) => {
    return axios.post('/auth/super-admin/login', { username, password })
}

const adminLocalLogin = (username, password) => {
    return axios.post('/auth/admin/login', { username, password })
}

// ===== User Data =====
const getCurrentUser = () => {
    return axios.get('/auth/me')
}

const logout = () => {
    return axios.post('/auth/logout')
}

// ===== GitHub Data Sync =====
const syncGitHubData = () => {
    return axios.post('/user/sync', { syncType: 'full' })
}

// ===== GitHub Proxy Endpoints (backend proxies GitHub API) =====
const getGitHubProfile = () => {
    return axios.get('/github/profile')
}

const syncGitHubProfile = () => {
    return axios.post('/github/profile/sync')
}

const getGitHubRepos = (params = {}) => {
    return axios.get('/github/repos', { params })
}

const syncGitHubRepos = () => {
    return axios.post('/github/repos/sync')
}

const getRepoDetails = (owner, name) => {
    return axios.get(`/github/repos/${owner}/${name}`)
}

const getRepoCommits = (owner, name, params = {}) => {
    return axios.get(`/github/repos/${owner}/${name}/commits`, { params })
}

const getRepoPullRequests = (owner, name, params = {}) => {
    return axios.get(`/github/repos/${owner}/${name}/pulls`, { params })
}

const getRepoIssues = (owner, name, params = {}) => {
    return axios.get(`/github/repos/${owner}/${name}/issues`, { params })
}

const getOrgRepos = (orgName, params = {}) => {
    return axios.get(`/github/org/${orgName}/repos`, { params })
}

// Legacy export (backward compatibility - uses OAuth)
const legacyGetAccessToken = (code) => {
    return axios.get(`/auth/token/${code}`)
}

export {
    getAccessToken,
    getRefreshedAccessToken,
    getAdminAccessToken,
    getAdminRefreshedToken,
    superAdminLogin,
    adminLocalLogin,
    getCurrentUser,
    logout,
    syncGitHubData,
    defaultGet,
    legacyGetAccessToken,
    // GitHub Proxy exports
    getGitHubProfile,
    syncGitHubProfile,
    getGitHubRepos,
    syncGitHubRepos,
    getRepoDetails,
    getRepoCommits,
    getRepoPullRequests,
    getRepoIssues,
    getOrgRepos,
}